const menuButton = document.getElementById("menuButton");
const header = document.getElementById("header");
const headerInner = document.querySelector(".header_inner");
const menuContactWrap = document.getElementById("js-menu_layer"); // menu_contact_wrapを取得
let isMenuOpened = false;

function toggleMenu() {
  isMenuOpened = !isMenuOpened;
  if (isMenuOpened) {
    // メニューを開いた時の処理
    menuButton.classList.add("is-opened");
    header.classList.add("is-opened");
    headerInner.classList.add("is-opened");
    menuContactWrap.classList.add("is-opened"); // menu_contact_wrapにクラスを追加
  } else {
    // メニューを閉じた時の処理
    menuButton.classList.remove("is-opened");
    header.classList.remove("is-opened");
    headerInner.classList.remove("is-opened");
    menuContactWrap.classList.remove("is-opened"); // menu_contact_wrapのクラスを削除
  }
}

menuButton.addEventListener("click", toggleMenu);
